<template>
  <v-expansion-panel :readonly="isEmpty" :class="{ 'pr-5': isEmpty }">
    <v-expansion-panel-header
      :ripple="!isEmpty"
      :hide-actions="isEmpty"
      :style="{ cursor: isEmpty ? 'default' : 'pointer' }"
    >
      <v-row no-gutters>
        <v-col cols="12">
          <slot name="header" />
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content v-if="!isEmpty">
      <v-row no-gutters>
        <v-col cols="12">
          <slot name="content" v-bind:buttonsInfo="buttonsInfo" />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import cuid from "cuid";

export default {
  name: "ExpansionPanel",
  props: {
    facilityId: {
      type: Number,
      required: true
    },
    gmbAddressId: {
      type: Number,
      required: true
    },
    isEmpty: {
      type: Boolean,
      default: true
    },
    itemData: {
      type: Object,
      required: true
    }
  },
  computed: {
    isAllDataFilled() {
      const keys = ["address", "phone_number", "website", "open_hours"];
      return this.itemData && keys.every(key => this.itemData[key].last_value);
    },
    buttonsInfo() {
      return [
        {
          id: cuid(),
          text: this.$t(
            `message.businessAddresses.quality.actionButtons.information.${
              this.isAllDataFilled ? "edit" : "add"
            }.text`
          ),
          label: this.$t(
            `message.businessAddresses.quality.actionButtons.information.${
              this.isAllDataFilled ? "edit" : "add"
            }.label`
          ),
          to: {
            name: "facility-details",
            params: { id: `${this.facilityId}` }
          }
        },
        {
          id: cuid(),
          text: this.$t(
            `message.businessAddresses.quality.actionButtons.reviews.text`
          ),
          label: this.$t(
            `message.businessAddresses.quality.actionButtons.reviews.label`
          ),
          to: {
            name: "reviews-list",
            query: { ids: `${this.gmbAddressId}` }
          }
        },
        {
          id: cuid(),
          text: this.$t(
            `message.businessAddresses.quality.actionButtons.photos.text`
          ),
          label: this.$t(
            `message.businessAddresses.quality.actionButtons.photos.label`
          ),
          to: {
            name: "photos-add",
            query: { ids: `${this.facilityId}` }
          }
        },
        {
          id: cuid(),
          text: this.$t(
            `message.businessAddresses.quality.actionButtons.posts.text`
          ),
          label: this.$t(
            `message.businessAddresses.quality.actionButtons.posts.label`
          ),
          to: {
            name: "posts",
            query: { ids: `${this.facilityId}` }
          }
        }
      ];
    }
  }
};
</script>
